// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-container {
  max-width: 1180px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 70px;
}

/* Responsive breakpoints */
@media (max-width: 600px) {
  .my-container {
    max-width: 100%;
    padding: 0 10px;
    margin-bottom: 60px;
  }
}

@media (min-width: 600px) {
  .my-container {
    max-width: 590px;
  }
}

@media (min-width: 768px) {
  .my-container {
    max-width: 760px;
  }
}

@media (min-width: 992px) {
  .my-container {
    max-width: 980px;
  }
}

@media (min-width: 1200px) {
  .my-container {
    max-width: 1220px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Game.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".my-container {\n  max-width: 1180px;\n  margin-right: auto;\n  margin-left: auto;\n  margin-bottom: 70px;\n}\n\n/* Responsive breakpoints */\n@media (max-width: 600px) {\n  .my-container {\n    max-width: 100%;\n    padding: 0 10px;\n    margin-bottom: 60px;\n  }\n}\n\n@media (min-width: 600px) {\n  .my-container {\n    max-width: 590px;\n  }\n}\n\n@media (min-width: 768px) {\n  .my-container {\n    max-width: 760px;\n  }\n}\n\n@media (min-width: 992px) {\n  .my-container {\n    max-width: 980px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .my-container {\n    max-width: 1220px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
